import { render } from "./ProjectManagementMenu.vue?vue&type=template&id=75c44c67&scoped=true"
import script from "./ProjectManagementMenu.vue?vue&type=script&lang=js"
export * from "./ProjectManagementMenu.vue?vue&type=script&lang=js"

import "./ProjectManagementMenu.vue?vue&type=style&index=0&id=75c44c67&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75c44c67"]])

export default __exports__